import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { isLaunched } from "../lib/launch";

/**
 * PreLaunchGate — while REACT_APP_LAUNCHED !== "true", redirect anonymous
 * visitors to the waitlist landing. Signed-in users (admin, demo, or real
 * pre-launched accounts) pass straight through.
 *
 * On launch day: set REACT_APP_LAUNCHED=true in frontend/.env and re-deploy.
 * Every gated route instantly opens for the public — zero code changes needed.
 */
export default function PreLaunchGate({ children }) {
  const { user } = useAuth();

  if (isLaunched()) return children;
  if (user) return children;   // any signed-in user (admin, demo, real) can access

  return <Navigate to="/" replace />;
}
